import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useContext, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { deletePersonAddress } from '@dealstack/frontend/app/services/Person.service.ts';
import { AddressRes } from '@dealstack/shared/lib/generated';

export const usePersonAddressesController = () => {
	const [selectedAddress, setSelectedAddress] = useState<AddressRes | null>(null);
	const [selectedDeleteAddress, setSelectedDeleteAddress] = useState<AddressRes | null>(null);

	const deleteAddressMutation = useMutation({
		mutationFn: deletePersonAddress,
	});

	const { refetchSelectedEntity, selectedEntityData } = useContext(CapManageControllerContext);

	const onAddressDelete = async () => {
		if (!selectedDeleteAddress?.personAddressId) {
			showToastV2({ state: 'error', message: 'Invalid address or missing ID' });
			return;
		}

		await deleteAddressMutation.mutateAsync(
			{
				personAddressId: selectedDeleteAddress.personAddressId,
			},
			{
				onSuccess: async () => {
					setSelectedDeleteAddress(null);
					await refetchSelectedEntity();

					showToastV2({ state: 'success', message: 'Address deleted successfully' });
				},
			}
		);
	};

	return {
		onAddressDelete,
		deleteLoading: deleteAddressMutation.isPending,
		selectedAddress,
		setSelectedAddress,
		selectedDeleteAddress,
		setSelectedDeleteAddress,
		selectedEntityData,
	};
};
